import React, { useState, useEffect, useCallback } from "react";
import NavbarMob from "../components/NavbarMob";
import Navbar from "../components/Navbar";
import Navbar2 from "../components/Navbar2";
import Footer from "../components/Footer";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import { useMediaQuery } from "react-responsive";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faFileAlt, faHistory } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import Navbar2Mob from "../components/Navbar2Mob";
import CreatableSelect from "react-select/creatable";
import { saveAs } from "file-saver";
import { debounce } from "lodash";

function Whatsapp() {
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [locationCategory, setLocationCategory] = useState(null);
    const [locationOptions, setLocationOptions] = useState([]);

    const [addressFilter, setAddressFilter] = useState("");

    const [categoryFilter, setCategoryFilter] = useState(null);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [jobTitleFilter, setJobTitleFilter] = useState("");

    const [jobs, setJobs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [whatsappLoading, setWhatsappLoading] = useState(false);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const [currentChunk, setCurrentChunk] = useState(0);
    const jobsPerBatch = 4;
    const navigate = useNavigate();
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [selectedCandidates, setSelectedCandidates] = useState([]);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [candidateOptions, setCandidateOptions] = useState([]);
    const [sendMessageLoading, setSendMessageLoading] = useState(false);
    const [customMessage, setCustomMessage] = useState("");
    const [jobPosts, setJobPosts] = useState([]);
    const [distinctWhatsAppNumbers, setDistinctWhatsAppNumbers] = useState([]);
    const [customWhatsappNumbers, setCustomWhatsappNumbers] = useState([]);
    const [selectedCustomNumbers, setSelectedCustomNumbers] = useState([]);
    const [selectedJobNumbers, setSelectedJobNumbers] = useState([]);

    const [message, setMessage] = useState("");
    const [messages, setMessages] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");

    // Define the "Select All" option
    const selectAllOption = { label: "Select All", value: "__selectAll__" };
    // const deselectAllOption = { label: "Deselect All", value: "__deselectAll__" };

    useEffect(() => {
        fetch(`${apiBaseUrl}/get-whatsapp-numbers`)
            .then((res) => {
                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                return res.json();
            })
            .then((data) => {
                if (data.success && Array.isArray(data.data)) {
                    const whatsappNumbers = data.data
                        .map((item) => item.number)
                        .filter((num) => typeof num === "string" && num.trim() !== "");
                    const uniqueNumbers = [...new Set(whatsappNumbers)];
                    const numberOptions = uniqueNumbers.map((num) => ({
                        label: num,
                        value: num,
                    }));

                    // Add both Select and Deselect options at the top
                    setCustomWhatsappNumbers([...numberOptions]);

                    // console.log("Custom WhatsApp numbers:", numberOptions);
                }
            })
            .catch((err) => console.error("Error fetching WhatsApp numbers:", err));
    }, [apiBaseUrl]);

    useEffect(() => {
        fetch(`${apiBaseUrl}/getjobposts`)
            .then((response) => response.json())
            .then((data) => {
                if (Array.isArray(data)) {
                    setJobPosts(data);
                } else {
                    console.error("Job posts data is not an array:", data);
                    setJobPosts([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching job posts:", error);
                setJobPosts([]);
            });
    }, [apiBaseUrl]);

    useEffect(() => {
        if (!Array.isArray(jobPosts)) return;

        const whatsappNumbers = jobPosts
            .filter((job) => typeof job.whatsapp_number === "string" && job.whatsapp_number.trim() !== "")
            .map((job) => ({
                number: job.whatsapp_number.trim(),
                shopName: job.shopName?.trim() || job.company_type?.trim() || "Unknown Shop",
            }));

        // Remove duplicates based on number
        const uniqueNumbers = Array.from(new Map(whatsappNumbers.map((item) => [item.number, item])).values());

        const numberOptions = uniqueNumbers.map((item) => ({
            label: `${item.shopName} - ${item.number}`, // display both shop name and number
            value: item.number, // still use number as value
        }));

        setDistinctWhatsAppNumbers([...numberOptions]);
    }, [jobPosts]);

    useEffect(() => {
        const fetchLocations = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/data`);
                if (response.ok) {
                    const data = await response.json();
                    const locations = data.states[0].districts.map((district) => ({
                        value: district,
                        label: district,
                    }));
                    setLocationOptions(locations);
                } else {
                    console.error("Failed to fetch locations");
                }
            } catch (error) {
                console.error("Error fetching locations:", error);
            }
        };
        fetchLocations();
    }, [apiBaseUrl]);

    useEffect(() => {
        const fetchEmployees = async () => {
            try {
                const res = await fetch(`${apiBaseUrl}/getAllEmployees`);
                const employees = await res.json();
                const options = employees.map((emp) => {
                    let number = emp.whatsapp_number;
                    if (number && !number.startsWith("91")) {
                        number = number.startsWith("+91") ? number.slice(1) : "91" + number;
                    }
                    return {
                        label: `${emp.company_name} (${number})`,
                        value: number,
                    };
                });
                setEmployeeOptions([...options]);
            } catch (error) {
                console.error("Error fetching employees:", error);
            }
        };

        const fetchCandidates = async () => {
            try {
                const res = await fetch(`${apiBaseUrl}/getAllCandidates`);
                const candidates = await res.json();
                // console.log("Raw candidate data:", candidates);
                const options = candidates
                    .map((cand) => {
                        let number = cand.WhatsApp;
                        if (!number) {
                            console.warn(`Missing WhatsApp number for candidate: ${cand.Name}`);
                            return null;
                        }
                        number = number.replace(/[\s+()-]/g, "");
                        if (!number.startsWith("91")) {
                            number = number.startsWith("+91") ? number.slice(1) : "91" + number;
                        }
                        if (!/^91\d{10}$/.test(number)) {
                            console.warn(`Invalid WhatsApp number for candidate ${cand.Name}: ${number}`);
                            return null;
                        }
                        return {
                            label: `${cand.Name} (${number})`,
                            value: number,
                        };
                    })
                    .filter(Boolean);
                setCandidateOptions([...options]);
            } catch (error) {
                console.error("Error fetching candidates:", error);
            }
        };

        fetchEmployees();
        fetchCandidates();
    }, [apiBaseUrl]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/datacompany`);
                if (response.ok) {
                    const data = await response.json();
                    const categories = data.states[0].districts.map((cat) => ({
                        value: cat,
                        label: cat,
                    }));
                    setCategoryOptions(categories);
                } else {
                    console.error("Failed to fetch company categories");
                }
            } catch (error) {
                console.error("Error fetching company categories:", error);
            }
        };
        fetchCategories();
    }, [apiBaseUrl]);

    const handleCustomWhatsAppNumberChange = (selectedOptions = []) => {
        if (selectedOptions.some((option) => option.value === "__selectAll__")) {
            // Select all options except "Select All" and "Deselect All"
            const allOptions = customWhatsappNumbers.filter(
                (option) => option.value !== "__selectAll__" && option.value !== "__deselectAll__"
            );
            setSelectedCustomNumbers(allOptions);
        } else if (selectedOptions.some((option) => option.value === "__deselectAll__")) {
            // Clear all selections
            setSelectedCustomNumbers([]);
        } else {
            // Normal case: remove special options
            setSelectedCustomNumbers(
                selectedOptions.filter(
                    (option) => option.value !== "__selectAll__" && option.value !== "__deselectAll__"
                ) || []
            );
        }
    };

    const handleJobPostWhatsAppNumberChange = (selectedOptions = []) => {
        if (selectedOptions.some((option) => option.value === "__selectAll__")) {
            const allOptions = distinctWhatsAppNumbers.filter(
                (option) => option.value !== "__selectAll__" && option.value !== "__deselectAll__"
            );
            setSelectedJobNumbers(allOptions);
        } else if (selectedOptions.some((option) => option.value === "__deselectAll__")) {
            setSelectedJobNumbers([]);
        } else {
            setSelectedJobNumbers(
                selectedOptions.filter(
                    (option) => option.value !== "__selectAll__" && option.value !== "__deselectAll__"
                ) || []
            );
        }
    };

    const handleEmployeeChange = (selectedOptions = []) => {
        if (selectedOptions.some((option) => option.value === "__selectAll__")) {
            const allOptions = employeeOptions.filter(
                (option) => option.value !== "__selectAll__" && option.value !== "__deselectAll__"
            );
            setSelectedEmployees(allOptions);
        } else if (selectedOptions.some((option) => option.value === "__deselectAll__")) {
            setSelectedEmployees([]);
        } else {
            setSelectedEmployees(
                selectedOptions.filter(
                    (option) => option.value !== "__selectAll__" && option.value !== "__deselectAll__"
                ) || []
            );
        }
    };

    const handleCandidateChange = (selectedOptions = []) => {
        if (selectedOptions.some((option) => option.value === "__selectAll__")) {
            const allOptions = candidateOptions.filter(
                (option) => option.value !== "__selectAll__" && option.value !== "__deselectAll__"
            );
            setSelectedCandidates(allOptions);
        } else if (selectedOptions.some((option) => option.value === "__deselectAll__")) {
            setSelectedCandidates([]);
        } else {
            setSelectedCandidates(
                selectedOptions.filter(
                    (option) => option.value !== "__selectAll__" && option.value !== "__deselectAll__"
                ) || []
            );
        }
    };

    const handleCreateWhatsAppNumber = async (inputValue) => {
        if (typeof inputValue !== "string") {
            console.error("Invalid inputValue type:", inputValue);
            alert("Invalid input: Please enter a valid phone number");
            return;
        }

        const newNumber = inputValue.trim().replace(/[\s+()-]/g, "");
        const normalizedNumber = normalizeNumber(newNumber);
        if (!normalizedNumber) {
            alert("Please enter a valid phone number (12 digits starting with 91)");
            return;
        }

        const numberExists = customWhatsappNumbers.some((option) => option.value === normalizedNumber);
        if (numberExists) {
            const newOption = { label: normalizedNumber, value: normalizedNumber };
            setSelectedCustomNumbers([...(selectedCustomNumbers || []), newOption]);
            return;
        }

        try {
            const response = await fetch(`${apiBaseUrl}/add-whatsapp-number`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ whatsapp_number: normalizedNumber }),
            });

            if (response.ok) {
                const newOption = { label: normalizedNumber, value: normalizedNumber };
                setCustomWhatsappNumbers([...(customWhatsappNumbers || []), newOption]);
                setSelectedCustomNumbers([...(selectedCustomNumbers || []), newOption]);
                alert(`New WhatsApp number ${normalizedNumber} added successfully!`);
            } else {
                const data = await response.json();
                console.error("Failed to add WhatsApp number:", data.message || response.statusText);
                alert(`Failed to add new WhatsApp number: ${data.message || "Unknown error"}`);
            }
        } catch (error) {
            console.error("Error adding WhatsApp number:", error);
            alert("Error adding new WhatsApp number");
        }
    };

    const normalizeNumber = (number) => {
        if (!number) return null;
        let normalized = number.replace(/[\s+()-]/g, "");
        normalized = normalized.startsWith("91")
            ? normalized
            : normalized.startsWith("+91")
                ? normalized.slice(1)
                : "91" + normalized;
        return /^91\d{10}$/.test(normalized) ? normalized : null;
    };

    const sendSelectedMessages = useCallback(
        debounce(async () => {
            // console.log(`sendSelectedMessages invoked at ${new Date().toISOString()}`);
            if (!customMessage.trim()) {
                alert("Please enter a message to send");
                return;
            }
            if (customMessage.length > 4096) {
                alert("Message exceeds maximum length of 4096 characters.");
                return;
            }
            if (
                !selectedCustomNumbers.length &&
                !selectedJobNumbers.length &&
                !selectedEmployees.length &&
                !selectedCandidates.length
            ) {
                alert("Please select at least one recipient (WhatsApp number, employee, or candidate)");
                return;
            }

            const phoneRegex = /^91\d{10}$/;
            const normalizedCustomNumbers = selectedCustomNumbers.map((num) => ({
                ...num,
                value: normalizeNumber(num.value),
                type: "Custom",
            }));
            const normalizedJobNumbers = selectedJobNumbers.map((num) => ({
                ...num,
                value: normalizeNumber(num.value),
                type: "Job",
            }));
            const normalizedEmployees = selectedEmployees.map((emp) => ({
                ...emp,
                value: normalizeNumber(emp.value),
                type: "Employee",
            }));
            const normalizedCandidates = selectedCandidates.map((cand) => ({
                ...cand,
                value: normalizeNumber(cand.value),
                type: "Candidate",
            }));

            const allNumbers = [
                ...normalizedCustomNumbers,
                ...normalizedJobNumbers,
                ...normalizedEmployees,
                ...normalizedCandidates,
            ];
            const uniqueNumbers = Array.from(new Map(allNumbers.map((num) => [num.value, num])).values());

            const invalidNumbers = uniqueNumbers.filter((num) => !num.value || !phoneRegex.test(num.value));
            if (invalidNumbers.length > 0) {
                alert(`Invalid phone numbers: ${invalidNumbers.map((n) => n.value || "undefined").join(", ")}`);
                return;
            }

            setSendMessageLoading(true);
            const results = [];

            const sendToApi = async (url, payload, type, number) => {
                const requestId = Date.now() + Math.random();
                try {
                    // console.log(`Sending request ${requestId} to ${url} with payload:`, payload);
                    const response = await fetch(url, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ ...payload, requestId }),
                    });
                    const data = await response.json();
                    // console.log(`Response for request ${requestId} from ${url} for ${number}:`,
                    //     {
                    //     status: response.status,
                    //     data,
                    // });
                    return {
                        to: number,
                        success: response.ok && data.success !== false,
                        message:
                            data.message || (response.ok ? "Message sent successfully" : `Failed: ${response.statusText}`),
                        type,
                    };
                } catch (error) {
                    console.error(`Error for request ${requestId} sending to ${url} for ${number}:`, error);
                    return {
                        to: number,
                        success: false,
                        message: error.message || `Network error sending to ${type} ${number}`,
                        type,
                    };
                }
            };

            for (const num of uniqueNumbers) {
                const number = num.value;
                const payload = { to: number, message: customMessage };
                let url;
                if (num.type === "Employee") {
                    url = `${apiBaseUrl}/send-whatsappemp`;
                } else if (num.type === "Candidate") {
                    url = `${apiBaseUrl}/send-whatsappcan`;
                } else if (num.type === "Custom") {
                    url = `${apiBaseUrl}/send-whatsappemp`;
                } else {
                    url = `${apiBaseUrl}/send-whatsapp`;
                }
                const result = await sendToApi(url, payload, num.type, number);
                results.push(result);
                await new Promise((resolve) => setTimeout(resolve, 1000));
            }

            const failed = results.filter((r) => !r.success);
            const succeeded = results.filter((r) => r.success);

            setSendMessageLoading(false);

            if (failed.length > 0) {
                // console.log(
                //     `Failed messages:\n${failed
                //         .map((r) => `${r.type} ${r.to}: ${r.message}`)
                //         .join("\n")}\n\nSuccessful messages: ${succeeded.length}`
                // );
                alert(`Failed to send to some numbers:\n${failed.map((r) => `${r.type} ${r.to}`).join("\n")}`);
            } else {
                alert(`All ${succeeded.length} messages sent successfully!`);
                setSelectedCustomNumbers([]);
                setSelectedJobNumbers([]);
                setSelectedEmployees([]);
                setSelectedCandidates([]);
            }
        }, 300),
        [customMessage, selectedCustomNumbers, selectedJobNumbers, selectedEmployees, selectedCandidates, apiBaseUrl]
    );

    const exportJobsToExcel = () => {
        if (jobs.length === 0) {
            alert("No jobs available to export");
            return;
        }

        // Determine filename based on selected location
        let fileName = "Jobs_List.xlsx";

        if (locationCategory && locationCategory.value) {
            // Clean the location name for filename: remove special chars, trim, replace spaces with _
            const locationName = locationCategory.value
                .trim()
                .replace(/[^a-zA-Z0-9\s-]/g, "") // Remove special characters
                .replace(/\s+/g, "_") // Replace spaces with underscores
                .replace(/_+$/, ""); // Remove trailing underscore

            if (locationName) {
                fileName = `Jobs_${locationName}.xlsx`;
            }
        }

        // Map and sort by Location (alphabetical)
        const jobData = jobs
            .map((job) => ({
                "Job ID": job.manualJobID ? job.manualJobID : job.job_id,
                Job: job.job,
                Salary:
                    job.min_salary && job.max_salary
                        ? `${job.min_salary} - ${job.max_salary}`
                        : job.min_salary || job.max_salary || job.salaryType || "Negotiable",
                Qualification: job.qualification || "N/A",
                Location: job.location || "N/A",
                Gender: job.gender_type || "N/A",
                Experience: job.experienceType || "N/A",
                Vacancy: job.vacancy || "N/A",
                "Start Time": job.start_time || "N/A",
                "End Time": job.end_time || "N/A",
                Description: job.job_description || "N/A",
            }))
            .sort((a, b) => {
                const locationA = (a.Location || "").toString().trim().toLowerCase();
                const locationB = (b.Location || "").toString().trim().toLowerCase();
                return locationA.localeCompare(locationB);
            });

        const worksheet = XLSX.utils.json_to_sheet(jobData);

        // Style header row: bold + centered
        const range = XLSX.utils.decode_range(worksheet["!ref"]);
        for (let C = range.s.c; C <= range.e.c; C++) {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
            if (worksheet[cellAddress]) {
                worksheet[cellAddress].s = {
                    font: { bold: true },
                    alignment: { horizontal: "center", vertical: "center" },
                };
            }
        }

        // Optional: left-align numbers
        for (let R = 1; R <= range.e.r; R++) {
            for (let C = range.s.c; C <= range.e.c; C++) {
                const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
                if (worksheet[cellAddress] && typeof worksheet[cellAddress].v === "number") {
                    worksheet[cellAddress].s = {
                        alignment: { horizontal: "left" },
                    };
                }
            }
        }

        // Column widths
        worksheet["!cols"] = [
            { wch: 15 }, // Job ID
            { wch: 30 }, // Job
            { wch: 20 }, // Salary
            { wch: 20 }, // Qualification
            { wch: 25 }, // Location
            { wch: 15 }, // Gender
            { wch: 20 }, // Experience
            { wch: 12 }, // Vacancy
            { wch: 15 }, // Start Time
            { wch: 15 }, // End Time
            { wch: 40 }, // Description
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Jobs");

        // Use dynamic filename
        XLSX.writeFile(workbook, fileName);
    };

    const exportJobsToTxt = () => {
        if (jobs.length === 0) {
            alert("No jobs available to export");
            return;
        }

        const hasMannarkkad = jobs.some((job) => job.location === "Mannarkkad");
        const phoneNumber = hasMannarkkad ? "*7356400746*" : "*9544500746*";
        const officialText = `RIYA HUB - ജോബ് പോർട്ടൽ\nനമ്പർ - ${phoneNumber}`;

        const jobText = jobs
            .map((job, index) => {
                const jobIDToDisplay = job.manualJobID ? job.manualJobID : job.job_id;
                return (
                    `*${index + 1}. ജോലി ID - ${jobIDToDisplay}\n` +
                    `ജോലി Title: ${job.job_title || ""}\n` +
                    `ശമ്പളം: ${job.min_salary && job.max_salary
                        ? `${job.min_salary} - ${job.max_salary}`
                        : job.max_salary
                            ? job.max_salary
                            : job.min_salary
                                ? job.min_salary
                                : job.salaryType || ""
                    }\n` +
                    `ബോയ്സ് / ഗേൾസ്: ${job.gender_type === "MALE"
                        ? "BOYS"
                        : job.gender_type === "FEMALE"
                            ? "GIRLS"
                            : job.gender_type === "MALE/FEMALE"
                                ? "BOYS/GIRLS"
                                : job.gender_type || ""
                    }\n` +
                    `ക്വാളിഫിക്കേഷൻ: ${job.qualification || ""}\n` +
                    `എക്സ്പീരിയൻസ്: ${job.experienceType || ""}\n` +
                    `ഒഴിവ്: ${job.vacancy || ""}\n` +
                    `സ്ഥലം: ${job.location || ""}`
                );
            })
            .join("\n\n");

        const fullText = `നാട്ടിലെ ജോലി ഒഴിവുകൾ\n\n${jobText}\n\n${officialText}`;

        try {
            const blob = new Blob([fullText], { type: "text/plain;charset=utf-8" });
            saveAs(blob, "Jobs_List.txt");
        } catch (error) {
            console.error("Error generating text file:", error);
            alert("Failed to generate text file");
        }
    };

    // const exportHistoryDataToExcel = async () => {
    //     try {
    //         const response = await fetch(`${apiBaseUrl}/getAllPackageSelections`);
    //         if (response.ok) {
    //             const data = await response.json();
    //             if (data && data.data) {
    //                 const sortedData = data.data.sort((a, b) => {
    //                     if (a.additionalCompanyName < b.additionalCompanyName) return -1;
    //                     if (a.additionalCompanyName > b.additionalCompanyName) return 1;
    //                     return new Date(b.created_at) - new Date(a.created_at);
    //                 });

    //                 const formattedData = sortedData.map((item) => {
    //                     const { id, ...rest } = item;
    //                     return {
    //                         ...rest,
    //                         created_at: new Date(item.created_at).toLocaleDateString("en-GB"),
    //                     };
    //                 });

    //                 const headers = [
    //                     "Company Name",
    //                     "Company Number",
    //                     "Company Location",
    //                     "Candidate Name",
    //                     "Candidate House Name",
    //                     "Candidate Experience",
    //                     "Applied Date",
    //                     "Candidate Mobile Number",
    //                 ];

    //                 const customData = formattedData.map((item) => [
    //                     item.additionalCompanyName || "N/A",
    //                     item.additionalMobileNumber || "N/A",
    //                     item.additionalLocation || "N/A",
    //                     item.customerName || "N/A",
    //                     item.houseName || "N/A",
    //                     item.experienced || "N/A",
    //                     item.created_at,
    //                     item.mobileNumber || "N/A",
    //                 ]);

    //                 customData.unshift(headers);

    //                 const ws = XLSX.utils.aoa_to_sheet(customData);
    //                 ws["!cols"] = [
    //                     { wch: 25 },
    //                     { wch: 25 },
    //                     { wch: 25 },
    //                     { wch: 25 },
    //                     { wch: 25 },
    //                     { wch: 25 },
    //                     { wch: 15 },
    //                     { wch: 25 },
    //                 ];

    //                 const wb = XLSX.utils.book_new();
    //                 XLSX.utils.book_append_sheet(wb, ws, "Package Selections");
    //                 XLSX.writeFile(wb, "PackageSelections.xlsx");
    //             } else {
    //                 console.error("No data available in the response");
    //                 alert("No data available to export");
    //             }
    //         } else {
    //             console.error("Error fetching data:", response.statusText);
    //             alert("Failed to fetch package selections");
    //         }
    //     } catch (error) {
    //         console.error("Error fetching or exporting data:", error);
    //         alert("Error exporting data to Excel");
    //     }
    // };

    //     const exportHistoryDataToExcel = async () => {
    //     // Validate date range
    //     if (!startDate || !endDate) {
    //         alert("Please select both Start Date and End Date to export Package Selections");
    //         return;
    //     }

    //     if (endDate < startDate) {
    //         alert("'End Date' cannot be earlier than 'Start Date'");
    //         return;
    //     }

    //     try {
    //         setLoading(true); // Reuse your existing loading state for feedback

    //         const response = await fetch(`${apiBaseUrl}/getAllPackageSelections`);
    //         if (!response.ok) {
    //             throw new Error("Failed to fetch data");
    //         }

    //         const result = await response.json();
    //         if (!result.data || result.data.length === 0) {
    //             alert("No package selection data available");
    //             setLoading(false);
    //             return;
    //         }

    //         // Define date range (inclusive)
    //         const from = new Date(startDate);
    //         from.setHours(0, 0, 0, 0);

    //         const to = new Date(endDate);
    //         to.setHours(23, 59, 59, 999);

    //         // Filter by date range
    //         const filteredData = result.data.filter(item => {
    //             const itemDate = new Date(item.created_at);
    //             return itemDate >= from && itemDate <= to;
    //         });

    //         if (filteredData.length === 0) {
    //             alert("No package selections found in the selected date range");
    //             setLoading(false);
    //             return;
    //         }

    //         // Sort: Company Name → Latest first
    //         const sortedData = filteredData.sort((a, b) => {
    //             if (a.additionalCompanyName !== b.additionalCompanyName) {
    //                 return a.additionalCompanyName.localeCompare(b.additionalCompanyName);
    //             }
    //             return new Date(b.created_at) - new Date(a.created_at); // newest first
    //         });

    //         // Format data
    //         const formattedData = sortedData.map(item => ({
    //             ...item,
    //             created_at: new Date(item.created_at).toLocaleDateString("en-GB"),
    //         }));

    //         const headers = [
    //             "Company Name",
    //             "Company Number",
    //             "Company Location",
    //             "Candidate Name",
    //             "Candidate House Name",
    //             "Candidate Experience",
    //             "Applied Date",
    //             "Candidate Mobile Number",
    //         ];

    //         const rows = formattedData.map(item => [
    //             item.additionalCompanyName || "N/A",
    //             item.additionalMobileNumber || "N/A",
    //             item.additionalLocation || "N/A",
    //             item.customerName || "N/A",
    //             item.houseName || "N/A",
    //             item.experienced || "N/A",
    //             item.created_at,
    //             item.mobileNumber || "N/A",
    //         ]);

    //         // Add headers
    //         const sheetData = [headers, ...rows];

    //         const ws = XLSX.utils.aoa_to_sheet(sheetData);
    //         ws["!cols"] = [
    //             { wch: 28 }, { wch: 20 }, { wch: 25 }, { wch: 25 },
    //             { wch: 25 }, { wch: 18 }, { wch: 16 }, { wch: 20 }
    //         ];

    //         const wb = XLSX.utils.book_new();
    //         XLSX.utils.book_append_sheet(wb, ws, "Package Selections");

    //         // Dynamic filename with date range
    //         const fromStr = from.toISOString().slice(0, 10);
    //         const toStr = to.toISOString().slice(0, 10);
    //         const fileName = `PackageSelections_${fromStr}_to_${toStr}.xlsx`;

    //         XLSX.writeFile(wb, fileName);

    //         alert(`Successfully exported ${filteredData.length} package selection(s)!`);

    //     } catch (error) {
    //         console.error("Export error:", error);
    //         alert("Failed to export data. Please try again.");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const exportHistoryDataToExcel = async () => {
        // Validate date range
        if (!startDate || !endDate) {
            alert("Please select both Start Date and End Date to export Package Selections");
            return;
        }

        if (endDate < startDate) {
            alert("'End Date' cannot be earlier than 'Start Date'");
            return;
        }

        try {
            setLoading(true);

            // Send dates as query parameters
            const params = new URLSearchParams({
                startDate: startDate, // expected format: YYYY-MM-DD
                endDate: endDate,
            });

            const response = await fetch(`${apiBaseUrl}/getAllPackageSelections?${params}`);

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(`Failed to fetch data: ${response.status} ${errorText}`);
            }

            const result = await response.json();

            // Check if data exists
            if (!result.data || result.data.length === 0) {
                alert("No package selections found in the selected date range");
                return;
            }

            const data = result.data;

            // Format date for Excel (en-GB: DD/MM/YYYY)
            const formattedData = data.map((item) => ({
                ...item,
                created_at: new Date(item.created_at).toLocaleDateString("en-GB"),
            }));

            // Excel headers
            const headers = [
                "Company Name",
                "Company Number",
                "Company Location",
                "Candidate Name",
                "Candidate House Name",
                "Candidate Experience",
                "Applied Date",
                "Candidate Mobile Number",
            ];

            // Map rows
            const rows = formattedData.map((item) => [
                item.additionalCompanyName || "N/A",
                item.additionalMobileNumber || "N/A",
                item.additionalLocation || "N/A",
                item.customerName || "N/A",
                item.houseName || "N/A",
                item.experienced || "N/A",
                item.created_at,
                item.mobileNumber || "N/A",
            ]);

            // Create worksheet
            const sheetData = [headers, ...rows];
            const ws = XLSX.utils.aoa_to_sheet(sheetData);

            // Column widths
            ws["!cols"] = [
                { wch: 28 },
                { wch: 20 },
                { wch: 25 },
                { wch: 25 },
                { wch: 25 },
                { wch: 18 },
                { wch: 16 },
                { wch: 20 },
            ];

            // Create workbook
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Package Selections");

            // Generate filename
            const fromStr = new Date(startDate).toISOString().slice(0, 10);
            const toStr = new Date(endDate).toISOString().slice(0, 10);
            const fileName = `PackageSelections_${fromStr}_to_${toStr}.xlsx`;

            // Download file
            XLSX.writeFile(wb, fileName);

            // Success message
            alert(`Successfully exported ${data.length} package selection(s)!`);
        } catch (error) {
            console.error("Export error:", error);
            alert("Failed to export data. Please try again.\n\nDetails: " + error.message);
        } finally {
            setLoading(false);
        }
    };

    const clearAllFilters = () => {
        setStartDate(null);
        setEndDate(null);
        setJobTitleFilter("");
        setLocationCategory(null);
        setCategoryFilter(null);
        setAddressFilter("");
        // Optional: reload jobs immediately after clearing
        fetchFilteredJobs(); // This will now show all active jobs up to today
        alert("All filters cleared!");
    };

    const fetchFilteredJobs = async () => {
        // Use current date if endDate is not selected
        const effectiveEndDate = endDate || new Date();

        // Validate: at least endDate (now possibly defaulted) must exist
        if (!effectiveEndDate) {
            alert("Please select an end date or leave it blank (today will be used)");
            return;
        }

        // Optional: if startDate is after effectiveEndDate, warn user
        if (startDate && startDate > effectiveEndDate) {
            alert("'Start Date' cannot be later than 'End Date'");
            return;
        }

        setLoading(true);
        try {
            const response = await fetch(`${apiBaseUrl}/getjobposts`);
            if (!response.ok) {
                throw new Error("Failed to fetch jobs");
            }
            const data = await response.json();

            const filteredJobs = data.filter((job) => {
                // Only show enabled jobs
                if (job.enable !== "on") return false;

                const jobDate = new Date(job.created_at);

                // End date filtering (inclusive)
                const jobEndDate = new Date(effectiveEndDate);
                jobEndDate.setHours(23, 59, 59, 999); // Include full end day

                let dateMatches = jobDate <= jobEndDate;

                // Start date filtering (if provided)
                if (startDate) {
                    const jobStartDate = new Date(startDate);
                    jobStartDate.setHours(0, 0, 0, 0);
                    dateMatches = dateMatches && jobDate >= jobStartDate;
                }

                // Location filtering
                let locationMatches = true;
                if (locationCategory && locationCategory.value) {
                    const jobLocation = (job.location || "").toLowerCase();
                    const searchLocation = locationCategory.value.toLowerCase();
                    locationMatches = jobLocation.includes(searchLocation);
                }

                // Category filtering
                let categoryMatches = true;
                if (categoryFilter && categoryFilter.value) {
                    const jobCategory = (job.company_type || "").toLowerCase();
                    const searchCategory = categoryFilter.value.toLowerCase();
                    categoryMatches = jobCategory.includes(searchCategory);
                }

                // Address filtering
                let addressMatches = true;
                if (addressFilter.trim()) {
                    const jobAddress = (job.address || "").toLowerCase();
                    const searchAddress = addressFilter.trim().toLowerCase();
                    addressMatches = jobAddress.includes(searchAddress);
                }

                // Job Title filtering
                let titleMatches = true;
                if (jobTitleFilter.trim()) {
                    const jobTitle = (job.job_title || "").toLowerCase();
                    const searchTitle = jobTitleFilter.trim().toLowerCase();
                    titleMatches = jobTitle.includes(searchTitle);
                }

                return dateMatches && locationMatches && categoryMatches && addressMatches && titleMatches;
            });

            setJobs(filteredJobs);

            if (filteredJobs.length === 0) {
                alert("No jobs found matching your filters");
            }
        } catch (error) {
            console.error("Error fetching jobs:", error);
            alert("Failed to load jobs. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const sendAllToWhatsApp = async () => {
        if (jobs.length === 0) {
            alert("No filtered jobs to send. Please apply filters first.");
            return;
        }

        const jobChunks = chunkJobs(jobs, jobsPerBatch);
        setWhatsappLoading(true);

        try {
            for (let i = 0; i < jobChunks.length; i++) {
                const jobBatch = jobChunks[i];
                const startIndex = i * jobsPerBatch;

                const jobText = jobBatch
                    .map((job, index) => {
                        const jobIDToDisplay = job.manualJobID ? job.manualJobID : job.job_id;
                        return (
                            `*${startIndex + index + 1}. ജോലി ID - ${jobIDToDisplay}\n` +
                            `ജോലി Title: ${job.job_title || "N/A"}\n` +
                            `ശമ്പളം: ${job.min_salary && job.max_salary
                                ? `${job.min_salary} - ${job.max_salary}`
                                : job.max_salary
                                    ? job.max_salary
                                    : job.min_salary
                                        ? job.min_salary
                                        : job.salaryType || "N/A"
                            }\n` +
                            `ബോയ്സ് / ഗേൾസ്: ${job.gender_type === "MALE"
                                ? "BOYS"
                                : job.gender_type === "FEMALE"
                                    ? "GIRLS"
                                    : job.gender_type === "MALE/FEMALE"
                                        ? "BOYS/GIRLS"
                                        : job.gender_type || "N/A"
                            }\n` +
                            `ക്വാളിഫിക്കേഷൻ: ${job.qualification}\n` +
                            `എക്സ്പീരിയൻസ്: ${job.experienceType || "N/A"}\n` +
                            `ഒഴിവ്: ${job.vacancy || "N/A"}\n` +
                            `സ്ഥലം: ${job.location || "N/A"}`
                        );
                    })
                    .join("\n\n");

                const phoneNumber = jobBatch.some((job) => job.location === "Mannarkkad") ? "917356400746" : "919544500746";
                const officialText = `RIYA HUB - ജോബ് പോർട്ടൽ\nനമ്പർ - ${phoneNumber}`;
                const fullText = `നാട്ടിലെ ജോലി ഒഴിവുകൾ\n\n${jobText}\n\n${officialText}`;

                const response = await fetch(`${apiBaseUrl}/send-whatsapp`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ to: phoneNumber, message: fullText }),
                });

                const data = await response.json();
                if (!response.ok) {
                    throw new Error(data.message || `Failed to send batch ${startIndex + 1}`);
                }

                // console.log(`Batch ${startIndex + 1}-${startIndex + jobBatch.length} sent to ${phoneNumber}`);
            }
            alert("All job batches sent successfully!");
        } catch (error) {
            console.error("Error sending WhatsApp messages:", error);
            alert(`Failed to send job batches: ${error.message}`);
        } finally {
            setWhatsappLoading(false);
        }
    };

    const chunkJobs = (jobs, chunkSize) => {
        const chunks = [];
        for (let i = 0; i < jobs.length; i += chunkSize) {
            chunks.push(jobs.slice(i, i + chunkSize));
        }
        return chunks;
    };

    useEffect(() => {
        const fetchMessages = () => {
            fetch(`${apiBaseUrl}/messages`)
                .then((response) => {
                    // console.log("Fetching messages from:", `${apiBaseUrl}/messages`);
                    // console.log("Response status:", response.status);
                    // console.log("Response headers:", [...response.headers.entries()]);

                    // Check if response is JSON
                    const contentType = response.headers.get("content-type");
                    if (!contentType || !contentType.includes("application/json")) {
                        return response.text().then((text) => {
                            // console.log("Non-JSON response:", text.substring(0, 100));
                            throw new Error(`Received non-JSON response (status: ${response.status})`);
                        });
                    }

                    if (!response.ok) {
                        return response.json().then((data) => {
                            throw new Error(data.message || `HTTP error! Status: ${response.status}`);
                        });
                    }

                    return response.json();
                })
                .then((data) => {
                    // console.log("Response data:", data);
                    if (data.success) {
                        // console.log("Messages fetched:", data.data);
                        setMessages(data.data || []);
                        setError("");
                    } else {
                        setError(data.message || "Failed to fetch messages");
                    }
                })
                .catch((err) => {
                    console.error("Fetch error:", err);
                    setError(err.message || "Failed to fetch messages");
                });
        };

        fetchMessages();
    }, [apiBaseUrl]);

    // Handle form submission (add or update)
    const handleSubmitMessage = (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        if (!message.trim()) {
            setError("Message is required");
            return;
        }

        fetch(editingId ? `${apiBaseUrl}/update-message/${editingId}` : `${apiBaseUrl}/add-message`, {
            method: editingId ? "PUT" : "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ message }),
        })
            .then((response) => {
                // console.log(
                //     "Submitting message to:",
                //     editingId ? `${apiBaseUrl}/update-message/${editingId}` : `${apiBaseUrl}/add-message`
                // );
                // console.log("Response status:", response.status);

                const contentType = response.headers.get("content-type");
                if (!contentType || !contentType.includes("application/json")) {
                    return response.text().then((text) => {
                        // console.log("Non-JSON response:", text.substring(0, 100));
                        throw new Error(`Received non-JSON response (status: ${response.status})`);
                    });
                }

                if (!response.ok) {
                    return response.json().then((data) => {
                        throw new Error(data.message || `HTTP error! Status: ${response.status}`);
                    });
                }

                return response.json();
            })
            .then((data) => {
                if (data.success) {
                    setSuccess(data.message);
                    if (editingId) {
                        setMessages(messages.map((msg) => (msg.id === editingId ? data.data : msg)));
                        setEditingId(null);
                    } else {
                        setMessages([...messages, data.data]);
                    }
                    setMessage("");
                } else {
                    setError(data.message || "Failed to save message");
                }
            })
            .catch((err) => {
                console.error("Fetch error:", err);
                setError(err.message || "Server error");
            });
    };

    // Handle edit button click
    const handleEditMessage = (msg) => {
        setMessage(msg.message);
        setEditingId(msg.id);
        setError("");
        setSuccess("");
    };

    // Handle delete button click
    const handleDeleteMessage = async (id) => {
        if (!window.confirm("Are you sure you want to delete this message?")) return;

        try {
            const response = await fetch(`${apiBaseUrl}/delete-message/${id}`, {
                method: "DELETE",
            });
            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || "Server error");
            }

            if (data.success) {
                setSuccess(data.message);
                setMessages(messages.filter((msg) => msg.id !== id));
            } else {
                setError(data.message);
            }
        } catch (err) {
            setError(err.message || "Server error");
            console.error(err);
        }
    };

    return (
        <div className="min-h-screen flex flex-col bg-gray-50 text-gray-800">
            {isMobile ? <NavbarMob /> : <Navbar />}
            <div className="md:flex hidden">
                <Navbar2 />
            </div>
            <div className="md:hidden flex flex-col">
                <Navbar2Mob />
            </div>
            <div className="lg:px-12 px-3 pt-2 flex gap-8 bg-gray-100 justify-between">
                <div>
                    <FontAwesomeIcon
                        icon={faFileExcel}
                        className="text-green-600 text-4xl cursor-pointer"
                        onClick={exportJobsToExcel}
                    />
                    <p>available job</p>
                </div>
                <div>
                    <FontAwesomeIcon
                        icon={faFileAlt}
                        className="text-blue-600 text-4xl cursor-pointer"
                        onClick={exportJobsToTxt}
                    />
                    <p>daily whatsapp group</p>
                </div>
                {/* <div>
                    <FontAwesomeIcon
                        icon={faFileAlt}
                        className="text-blue-600 text-4xl cursor-pointer"
                        onClick={exportJobsToExcel}
                    />
                    <p>fb posting</p>
                </div> */}
                <div>
                    <FontAwesomeIcon
                        icon={faHistory}
                        className="text-green-600 text-4xl cursor-pointer"
                        onClick={exportHistoryDataToExcel}
                    />
                    <p>applied candidate</p>
                </div>
            </div>
            <div className="lg:px-12 px-3 lg:py-12 py-3 flex flex-col gap-8 bg-gray-100">
                <div className="flex flex-col md:flex-row gap-4 justify-center items-center">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Start Date</label>
                        <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            placeholderText="Select start date"
                            dateFormat="dd/MM/yyyy"
                            className="w-full py-2 px-4 border border-gray-300 rounded-lg"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">End Date</label>
                        <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            placeholderText="Select end date"
                            dateFormat="dd/MM/yyyy"
                            className="w-full py-2 px-4 border border-gray-300 rounded-lg"
                        />
                    </div>
                    <div className="w-64">
                        <label className="block text-sm font-medium text-gray-700">Job Title</label>
                        <input
                            type="text"
                            value={jobTitleFilter}
                            onChange={(e) => setJobTitleFilter(e.target.value)}
                            placeholder="e.g. Driver, Nurse"
                            className="w-full py-2 px-4 border border-gray-300 rounded-lg"
                        />
                    </div>
                    <div className="w-64">
                        <label className="block text-sm font-medium text-gray-700">Location</label>
                        <Select
                            options={locationOptions}
                            value={locationCategory}
                            onChange={setLocationCategory}
                            placeholder="Select location"
                        />
                    </div>
                    <div className="w-64">
                        <label className="block text-sm font-medium text-gray-700">Category</label>
                        <Select
                            options={categoryOptions}
                            value={categoryFilter}
                            onChange={setCategoryFilter}
                            placeholder="All categories"
                            isClearable
                        />
                    </div>
                    <div className="w-64">
                        <label className="block text-sm font-medium text-gray-700">Address</label>
                        <input
                            type="text"
                            value={addressFilter}
                            onChange={(e) => setAddressFilter(e.target.value)}
                            placeholder="e.g. Palakkad, near bus stand"
                            className="w-full py-2 px-4 border border-gray-300 rounded-lg"
                        />
                    </div>
                </div>
                <div className="flex justify-center gap-6 ">
                    <button
                        onClick={fetchFilteredJobs}
                        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-10 rounded-lg transition shadow-md"
                    >
                        Apply Filters & Load Jobs
                    </button>

                    <button
                        onClick={clearAllFilters}
                        className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-3 px-10 rounded-lg transition shadow-md"
                    >
                        Clear All Filters
                    </button>
                </div>
                {/* <button
                    onClick={fetchFilteredJobs}
                    className="mt-6 bg-blue-500 text-white font-semibold py-2 px-8 rounded-lg"
                >
                    Filter Jobs
                </button> */}

                {loading ? (
                    <div className="text-center">Loading...</div>
                ) : (
                    <div className="grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
                        {jobs.map((job) => (
                            <div key={job.job_id} className="bg-white p-6 shadow-lg rounded-lg border">
                                <h3 className="text-2xl font-bold text-gray-800">{job.job_title || "N/A"}</h3>
                                <p className="text-lg font-semibold text-blue-600">{job.company_type || "N/A"}</p>
                                <p className="text-lg font-semibold text-gray-800">Job ID : {job.job_id || "N/A"}</p>
                                <p className="text-base text-gray-700">
                                    <strong>Location:</strong> {job.location || "N/A"}
                                </p>
                                {job.address && (
                                    <p className="text-base text-gray-600">
                                        <strong>Address:</strong> {job.address}
                                    </p>
                                )}
                                <p className="text-xl font-bold text-green-700 mt-2">
                                    ₹
                                    {job.min_salary && job.max_salary
                                        ? `${job.min_salary} - ${job.max_salary}`
                                        : job.min_salary || job.max_salary || job.salaryType || "Negotiable"}
                                </p>
                                <p className="text-sm text-gray-500 mt-2">
                                    Posted: {new Date(job.created_at).toLocaleDateString("en-GB")}
                                </p>
                            </div>
                        ))}
                    </div>
                )}

                {jobs.length > 0 && (
                    <div className="flex flex-col items-center gap-4">
                        <button
                            onClick={sendAllToWhatsApp}
                            className="bg-blue-500 text-white py-2 px-8 rounded-lg"
                            disabled={whatsappLoading}
                        >
                            {whatsappLoading ? "Sending Jobs..." : "Send All Filtered Jobs"}
                        </button>
                    </div>
                )}

                <div className="flex flex-col items-center gap-4">
                    <div className="flex flex-col md:flex-row gap-4 w-full">
                        {/* <div className="flex flex-col w-full md:w-1/2">
                            <label className="font-semibold">New WhatsApp Numbers</label>
                            <CreatableSelect
                                isMulti
                                options={customWhatsappNumbers}
                                value={selectedCustomNumbers}
                                onChange={handleCustomWhatsAppNumberChange}
                                onCreateOption={handleCreateWhatsAppNumber}
                                placeholder="Select or type new number"
                                formatCreateLabel={(inputValue) => `Add new number: ${inputValue}`}
                            />
                        </div> */}
                        <div className="flex flex-col w-full md:w-1/2 gap-6">
                            <div className="flex flex-col">
                                <div className="flex flex-row items-center justify-between">
                                    <label className="font-semibold">New WhatsApp Numbers</label>
                                    <button
                                        className="w-max border border-1 rounded-lg bg-blue-500 px-2 py-1 mb-2 text-sm text-white"
                                        onClick={() => {
                                            handleCustomWhatsAppNumberChange([selectAllOption]);
                                        }}
                                    >
                                        Select All
                                    </button>
                                </div>

                                <div className="flex-row">
                                    <CreatableSelect
                                        isMulti
                                        options={customWhatsappNumbers}
                                        value={selectedCustomNumbers}
                                        onChange={handleCustomWhatsAppNumberChange}
                                        onCreateOption={handleCreateWhatsAppNumber}
                                        placeholder="Select or type new number"
                                        formatCreateLabel={(inputValue) => `Add new number: ${inputValue}`}
                                        className="w-full"
                                        classNamePrefix="select"
                                        closeMenuOnSelect={false}
                                        styles={{
                                            // 👇 scrollable area for selected items
                                            valueContainer: (provided) => ({
                                                ...provided,
                                                maxHeight: 150, // height limit before scroll
                                                overflowY: "auto", // enables vertical scroll
                                                display: "flex",
                                                flexWrap: "wrap",
                                            }),
                                            // 👇 scrollable dropdown menu
                                            menuList: (provided) => ({
                                                ...provided,
                                                maxHeight: 200,
                                                overflowY: "auto",
                                            }),
                                            menu: (provided) => ({
                                                ...provided,
                                                zIndex: 9999,
                                            }),
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col ">
                                <div className="flex flex-row items-center justify-between">
                                    <label className="font-semibold">WhatsApp Numbers from Job Postings</label>
                                    <button
                                        className="w-max border border-1 rounded-lg bg-blue-500 px-2 py-1 mb-2 text-sm text-white"
                                        onClick={() => {
                                            handleJobPostWhatsAppNumberChange([selectAllOption]);
                                        }}
                                    >
                                        Select All
                                    </button>
                                </div>
                                <Select
                                    isMulti
                                    options={distinctWhatsAppNumbers}
                                    value={selectedJobNumbers}
                                    onChange={handleJobPostWhatsAppNumberChange}
                                    placeholder="Select WhatsApp numbers"
                                    className="w-full"
                                    classNamePrefix="select"
                                    menuPlacement="auto"
                                    closeMenuOnSelect={false}
                                    styles={{
                                        // Makes selected values scrollable
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            maxHeight: 150, // height of selected area (adjust as needed)
                                            overflowY: "auto", // enables scrolling
                                            display: "flex",
                                            flexWrap: "wrap",
                                        }),
                                        // Keeps dropdown menu scrollable and neat
                                        menuList: (provided) => ({
                                            ...provided,
                                            maxHeight: 200,
                                            overflowY: "auto",
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            zIndex: 9999,
                                        }),
                                    }}
                                />
                            </div>
                        </div>

                        <div className="flex flex-col w-full md:w-1/2">
                            <label className="font-semibold">Custom Message</label>
                            <textarea
                                value={customMessage}
                                onChange={(e) => setCustomMessage(e.target.value)}
                                placeholder="Enter your custom message here"
                                className="w-full p-4 border border-gray-300 rounded-lg"
                                rows="5"
                            />
                        </div>
                        <div className="flex flex-col w-full md:w-1/2">
                            <label className="font-semibold">{editingId ? "Edit Message" : "Add Message"}</label>

                            {/* Form with Textarea */}
                            <form onSubmit={handleSubmitMessage}>
                                <div className="mb-3">
                                    <textarea
                                        className="w-full p-4 border border-gray-300 rounded-lg"
                                        rows="5"
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        placeholder="Enter your message (1-500 characters)"
                                        maxLength={500}
                                    />
                                </div>
                                <div className="flex justify-center gap-x-2">
                                    <button
                                        type="submit"
                                        className="bg-blue-500 py-2 px-3 rounded-lg text-white font-semibold"
                                    >
                                        {editingId ? "Update Message" : "Add Message"}
                                    </button>
                                    {editingId && (
                                        <button
                                            type="button"
                                            className="bg-red-500 py-2 px-3 rounded-lg text-white font-semibold"
                                            onClick={() => {
                                                setMessage("");
                                                setEditingId(null);
                                                setError("");
                                                setSuccess("");
                                            }}
                                        >
                                            Cancel
                                        </button>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                    {/* <div className="flex flex-col w-full">
                        <label className="font-semibold">Select Employees</label>
                        <CreatableSelect
                            isMulti
                            options={employeeOptions}
                            value={selectedEmployees}
                            onChange={handleEmployeeChange}
                            placeholder="Select employees"
                        />
                    </div> */}
                    <div className="flex flex-col w-full md:w-1/2 gap-4">
                        {/* Messages List */}
                        <label className="font-semibold">Added Messages</label>
                        {messages.length === 0 ? (
                            <p>No messages available.</p>
                        ) : (
                            <ul className="list-group">
                                {messages.map((msg) => (
                                    <li
                                        key={msg.id}
                                        className="flex justify-between items-center mb-2 border-gray-300 border-2 rounded-lg p-1 pl-3"
                                    >
                                        <span>{msg.message}</span>
                                        <div className="flex gap-2">
                                            <button
                                                className="bg-blue-500 py-1 px-2 rounded-lg text-white font-semibold"
                                                onClick={() => handleEditMessage(msg)}
                                            >
                                                Edit
                                            </button>
                                            <button
                                                className="bg-red-500 py-1 px-2 rounded-lg text-white font-semibold"
                                                onClick={() => handleDeleteMessage(msg.id)}
                                            >
                                                Delete
                                            </button>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    <div className="flex flex-col w-full">
                        <div className="flex flex-row items-center justify-between">
                            <label className="font-semibold">Select Employers</label>
                            <button
                                className="w-max border border-1 rounded-lg bg-blue-500 px-2 py-1 mb-2 text-sm text-white"
                                onClick={() => {
                                    handleEmployeeChange([selectAllOption]);
                                }}
                            >
                                Select All
                            </button>
                        </div>
                        <CreatableSelect
                            isMulti
                            options={employeeOptions}
                            value={selectedEmployees}
                            onChange={handleEmployeeChange}
                            placeholder="Select employees"
                            className="w-full"
                            classNamePrefix="select"
                            closeMenuOnSelect={false}
                            styles={{
                                // Scrollable selected values
                                valueContainer: (provided) => ({
                                    ...provided,
                                    maxHeight: 150, // max height for selected items
                                    overflowY: "auto", // enable vertical scroll
                                    display: "flex",
                                    flexWrap: "wrap",
                                }),
                                // Scrollable dropdown menu
                                menuList: (provided) => ({
                                    ...provided,
                                    maxHeight: 200,
                                    overflowY: "auto",
                                }),
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9999,
                                }),
                            }}
                        />
                    </div>

                    {/* <div className="flex flex-col w-full">
                        <label className="font-semibold mt-4">Select Candidates</label>
                        <CreatableSelect
                            isMulti
                            options={candidateOptions}
                            value={selectedCandidates}
                            onChange={handleCandidateChange}
                            placeholder="Select candidates"
                        />
                    </div> */}
                    <div className="flex flex-col w-full">
                        <div className="flex flex-row items-center justify-between">
                            <label className="font-semibold">Select Candidates</label>
                            <button
                                className="w-max border border-1 rounded-lg bg-blue-500 px-2 py-1 mb-2 text-sm text-white"
                                onClick={() => {
                                    handleCandidateChange([selectAllOption]);
                                }}
                            >
                                Select All
                            </button>
                        </div>
                        <CreatableSelect
                            isMulti
                            options={candidateOptions}
                            value={selectedCandidates}
                            onChange={handleCandidateChange}
                            placeholder="Select candidates"
                            className="w-full"
                            classNamePrefix="select"
                            closeMenuOnSelect={false}
                            styles={{
                                // Scrollable selected values area
                                valueContainer: (provided) => ({
                                    ...provided,
                                    maxHeight: 150, // max height before scroll
                                    overflowY: "auto", // vertical scroll
                                    display: "flex",
                                    flexWrap: "wrap",
                                }),
                                // Scrollable dropdown menu
                                menuList: (provided) => ({
                                    ...provided,
                                    maxHeight: 200,
                                    overflowY: "auto",
                                }),
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9999,
                                }),
                            }}
                        />
                    </div>

                    <button
                        onClick={sendSelectedMessages}
                        className="mt-4 bg-blue-600 text-white py-2 px-6 rounded-lg"
                        disabled={sendMessageLoading}
                    >
                        {sendMessageLoading ? "Sending Messages..." : "Send Custom Message"}
                    </button>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Whatsapp;
